
const error = {
  state: {
    error: {
      errorNo: 0
    }
  },
  mutations: {
      COMMIT_ERROR: (state, errorNo) => {
      state.error.errorNo = errorNo;
    }
  },
  actions: {
    CommitError({ commit }) {
      commit('COMMIT_ERROR')
    }
  }
}

export default error



// WEBPACK FOOTER //
// ./src/store/modules/error.js